var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      staticClass: "notification-card-wrapper",
      attrs: { persistent: "", "max-width": "600px" },
      model: {
        value: _vm.isVisible,
        callback: function($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible"
      }
    },
    [
      _c("div", { staticClass: "notification-card" }, [
        _c(
          "div",
          {
            staticClass: "notification-image",
            style: {
              "background-image": "url(" + _vm.imageUrl + ")"
            }
          },
          [
            _c("div", { staticClass: "notification-title" }, [
              _c("div", { staticClass: "notification-title-content" }, [
                _c("h1", [_vm._v(_vm._s(_vm.title))])
              ])
            ])
          ]
        ),
        _c(
          "div",
          { staticClass: "notification-content" },
          [
            _vm._l(_vm.content, function(cont, i) {
              return [
                cont.contentType === "p"
                  ? _c(
                      "p",
                      { key: i },
                      [
                        Array.isArray(cont.content)
                          ? [
                              _vm._l(cont.content, function(span, j) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      key: i + "-" + j,
                                      style: span.style ? span.style : ""
                                    },
                                    [_vm._v(" " + _vm._s(span.text) + " ")]
                                  )
                                ]
                              })
                            ]
                          : [_vm._v(" " + _vm._s(cont.content) + " ")]
                      ],
                      2
                    )
                  : _vm._e()
              ]
            })
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "notification-actions" },
          [
            _vm.link
              ? _c(
                  "v-btn",
                  {
                    attrs: { color: "info", text: "" },
                    on: {
                      click: function($event) {
                        return _vm.navigateToLink(_vm.link.url)
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.link.label) + " ")]
                )
              : _vm._e(),
            _c(
              "v-btn",
              {
                staticClass: "pull-right",
                attrs: { color: "secondary" },
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              },
              [_vm._v(" Okay ")]
            ),
            !_vm.link
              ? _c("div", { staticClass: "notification-end" })
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }